// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomTxCardFieldDefinitionsList from './data'

export default function DataVaxiomTxCardFieldDefinitionsListFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList">
      <DataVaxiomTxCardFieldDefinitionsList {...props}>
        {children}
      </DataVaxiomTxCardFieldDefinitionsList>
    </Flow>
  )
}
